var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollect4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 576,
    height: 627,
    viewBox: "0 0 576 627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_19",
    x: 0,
    y: 149,
    width: 576,
    height: 335,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.059
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14579",
    "data-name": "Group 14579",
    transform: "translate(-229 -8369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14489",
    "data-name": "Group 14489",
    transform: "translate(628.807 8407) rotate(90)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2957",
    "data-name": "Ellipse 2957",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2958",
    "data-name": "Ellipse 2958",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2959",
    "data-name": "Ellipse 2959",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2960",
    "data-name": "Ellipse 2960",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2833",
    "data-name": "Ellipse 2833",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2834",
    "data-name": "Ellipse 2834",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2835",
    "data-name": "Ellipse 2835",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2836",
    "data-name": "Ellipse 2836",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2961",
    "data-name": "Ellipse 2961",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2963",
    "data-name": "Ellipse 2963",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2964",
    "data-name": "Ellipse 2964",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2837",
    "data-name": "Ellipse 2837",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2839",
    "data-name": "Ellipse 2839",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2840",
    "data-name": "Ellipse 2840",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2965",
    "data-name": "Ellipse 2965",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2967",
    "data-name": "Ellipse 2967",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2968",
    "data-name": "Ellipse 2968",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2841",
    "data-name": "Ellipse 2841",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2843",
    "data-name": "Ellipse 2843",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2844",
    "data-name": "Ellipse 2844",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2969",
    "data-name": "Ellipse 2969",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2845",
    "data-name": "Ellipse 2845",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2971",
    "data-name": "Ellipse 2971",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2847",
    "data-name": "Ellipse 2847",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2973",
    "data-name": "Ellipse 2973",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2974",
    "data-name": "Ellipse 2974",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2975",
    "data-name": "Ellipse 2975",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2976",
    "data-name": "Ellipse 2976",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2849",
    "data-name": "Ellipse 2849",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2850",
    "data-name": "Ellipse 2850",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2851",
    "data-name": "Ellipse 2851",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2852",
    "data-name": "Ellipse 2852",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2977",
    "data-name": "Ellipse 2977",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2979",
    "data-name": "Ellipse 2979",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2980",
    "data-name": "Ellipse 2980",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2853",
    "data-name": "Ellipse 2853",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2855",
    "data-name": "Ellipse 2855",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2856",
    "data-name": "Ellipse 2856",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2981",
    "data-name": "Ellipse 2981",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2983",
    "data-name": "Ellipse 2983",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2984",
    "data-name": "Ellipse 2984",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2857",
    "data-name": "Ellipse 2857",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2859",
    "data-name": "Ellipse 2859",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2860",
    "data-name": "Ellipse 2860",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2985",
    "data-name": "Ellipse 2985",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2861",
    "data-name": "Ellipse 2861",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2987",
    "data-name": "Ellipse 2987",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2863",
    "data-name": "Ellipse 2863",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2925",
    "data-name": "Ellipse 2925",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2926",
    "data-name": "Ellipse 2926",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2927",
    "data-name": "Ellipse 2927",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2928",
    "data-name": "Ellipse 2928",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2865",
    "data-name": "Ellipse 2865",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2798",
    "data-name": "Ellipse 2798",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2866",
    "data-name": "Ellipse 2866",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2799",
    "data-name": "Ellipse 2799",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2929",
    "data-name": "Ellipse 2929",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2931",
    "data-name": "Ellipse 2931",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2932",
    "data-name": "Ellipse 2932",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2867",
    "data-name": "Ellipse 2867",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2868",
    "data-name": "Ellipse 2868",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2801",
    "data-name": "Ellipse 2801",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2933",
    "data-name": "Ellipse 2933",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2935",
    "data-name": "Ellipse 2935",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2936",
    "data-name": "Ellipse 2936",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2869",
    "data-name": "Ellipse 2869",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2870",
    "data-name": "Ellipse 2870",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2803",
    "data-name": "Ellipse 2803",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2937",
    "data-name": "Ellipse 2937",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2871",
    "data-name": "Ellipse 2871",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2939",
    "data-name": "Ellipse 2939",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2805",
    "data-name": "Ellipse 2805",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2941",
    "data-name": "Ellipse 2941",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2942",
    "data-name": "Ellipse 2942",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2943",
    "data-name": "Ellipse 2943",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2944",
    "data-name": "Ellipse 2944",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2872",
    "data-name": "Ellipse 2872",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2807",
    "data-name": "Ellipse 2807",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2873",
    "data-name": "Ellipse 2873",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2808",
    "data-name": "Ellipse 2808",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2945",
    "data-name": "Ellipse 2945",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2947",
    "data-name": "Ellipse 2947",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2948",
    "data-name": "Ellipse 2948",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2874",
    "data-name": "Ellipse 2874",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2875",
    "data-name": "Ellipse 2875",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2810",
    "data-name": "Ellipse 2810",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2949",
    "data-name": "Ellipse 2949",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2951",
    "data-name": "Ellipse 2951",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2952",
    "data-name": "Ellipse 2952",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2876",
    "data-name": "Ellipse 2876",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2877",
    "data-name": "Ellipse 2877",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2812",
    "data-name": "Ellipse 2812",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2953",
    "data-name": "Ellipse 2953",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2878",
    "data-name": "Ellipse 2878",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2955",
    "data-name": "Ellipse 2955",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2814",
    "data-name": "Ellipse 2814",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2879",
    "data-name": "Ellipse 2879",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2880",
    "data-name": "Ellipse 2880",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2881",
    "data-name": "Ellipse 2881",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2882",
    "data-name": "Ellipse 2882",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2885",
    "data-name": "Ellipse 2885",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2887",
    "data-name": "Ellipse 2887",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2888",
    "data-name": "Ellipse 2888",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2891",
    "data-name": "Ellipse 2891",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2893",
    "data-name": "Ellipse 2893",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2894",
    "data-name": "Ellipse 2894",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2897",
    "data-name": "Ellipse 2897",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2900",
    "data-name": "Ellipse 2900",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2902",
    "data-name": "Ellipse 2902",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2903",
    "data-name": "Ellipse 2903",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2904",
    "data-name": "Ellipse 2904",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2905",
    "data-name": "Ellipse 2905",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2989",
    "data-name": "Ellipse 2989",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2990",
    "data-name": "Ellipse 2990",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2991",
    "data-name": "Ellipse 2991",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2992",
    "data-name": "Ellipse 2992",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2908",
    "data-name": "Ellipse 2908",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2910",
    "data-name": "Ellipse 2910",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2911",
    "data-name": "Ellipse 2911",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2993",
    "data-name": "Ellipse 2993",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2995",
    "data-name": "Ellipse 2995",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2996",
    "data-name": "Ellipse 2996",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2914",
    "data-name": "Ellipse 2914",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2916",
    "data-name": "Ellipse 2916",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2917",
    "data-name": "Ellipse 2917",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2997",
    "data-name": "Ellipse 2997",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2999",
    "data-name": "Ellipse 2999",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3000",
    "data-name": "Ellipse 3000",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2920",
    "data-name": "Ellipse 2920",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3001",
    "data-name": "Ellipse 3001",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3003",
    "data-name": "Ellipse 3003",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -117.914)",
    fill: "#090909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14490",
    "data-name": "Group 14490",
    transform: "translate(280.528 8838) rotate(90)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2957-2",
    "data-name": "Ellipse 2957",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2958-2",
    "data-name": "Ellipse 2958",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2959-2",
    "data-name": "Ellipse 2959",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2960-2",
    "data-name": "Ellipse 2960",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2833-2",
    "data-name": "Ellipse 2833",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2834-2",
    "data-name": "Ellipse 2834",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2835-2",
    "data-name": "Ellipse 2835",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2836-2",
    "data-name": "Ellipse 2836",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2961-2",
    "data-name": "Ellipse 2961",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2963-2",
    "data-name": "Ellipse 2963",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2964-2",
    "data-name": "Ellipse 2964",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2837-2",
    "data-name": "Ellipse 2837",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2839-2",
    "data-name": "Ellipse 2839",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2840-2",
    "data-name": "Ellipse 2840",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2965-2",
    "data-name": "Ellipse 2965",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2967-2",
    "data-name": "Ellipse 2967",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2968-2",
    "data-name": "Ellipse 2968",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2841-2",
    "data-name": "Ellipse 2841",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2843-2",
    "data-name": "Ellipse 2843",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2844-2",
    "data-name": "Ellipse 2844",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2969-2",
    "data-name": "Ellipse 2969",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2845-2",
    "data-name": "Ellipse 2845",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2971-2",
    "data-name": "Ellipse 2971",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -107.783)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2847-2",
    "data-name": "Ellipse 2847",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -42.391)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2973-2",
    "data-name": "Ellipse 2973",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2974-2",
    "data-name": "Ellipse 2974",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2975-2",
    "data-name": "Ellipse 2975",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2976-2",
    "data-name": "Ellipse 2976",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2849-2",
    "data-name": "Ellipse 2849",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2850-2",
    "data-name": "Ellipse 2850",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2851-2",
    "data-name": "Ellipse 2851",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2852-2",
    "data-name": "Ellipse 2852",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2977-2",
    "data-name": "Ellipse 2977",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2979-2",
    "data-name": "Ellipse 2979",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2980-2",
    "data-name": "Ellipse 2980",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2853-2",
    "data-name": "Ellipse 2853",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2855-2",
    "data-name": "Ellipse 2855",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2856-2",
    "data-name": "Ellipse 2856",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2981-2",
    "data-name": "Ellipse 2981",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2983-2",
    "data-name": "Ellipse 2983",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2984-2",
    "data-name": "Ellipse 2984",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2857-2",
    "data-name": "Ellipse 2857",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2859-2",
    "data-name": "Ellipse 2859",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2860-2",
    "data-name": "Ellipse 2860",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2985-2",
    "data-name": "Ellipse 2985",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2861-2",
    "data-name": "Ellipse 2861",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2987-2",
    "data-name": "Ellipse 2987",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -96.73)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2863-2",
    "data-name": "Ellipse 2863",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -31.339)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2925-2",
    "data-name": "Ellipse 2925",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2926-2",
    "data-name": "Ellipse 2926",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2927-2",
    "data-name": "Ellipse 2927",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2928-2",
    "data-name": "Ellipse 2928",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2865-2",
    "data-name": "Ellipse 2865",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2798-2",
    "data-name": "Ellipse 2798",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2866-2",
    "data-name": "Ellipse 2866",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2799-2",
    "data-name": "Ellipse 2799",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2929-2",
    "data-name": "Ellipse 2929",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2931-2",
    "data-name": "Ellipse 2931",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2932-2",
    "data-name": "Ellipse 2932",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2867-2",
    "data-name": "Ellipse 2867",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2868-2",
    "data-name": "Ellipse 2868",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2801-2",
    "data-name": "Ellipse 2801",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2933-2",
    "data-name": "Ellipse 2933",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2935-2",
    "data-name": "Ellipse 2935",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2936-2",
    "data-name": "Ellipse 2936",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2869-2",
    "data-name": "Ellipse 2869",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2870-2",
    "data-name": "Ellipse 2870",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2803-2",
    "data-name": "Ellipse 2803",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2937-2",
    "data-name": "Ellipse 2937",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2871-2",
    "data-name": "Ellipse 2871",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2939-2",
    "data-name": "Ellipse 2939",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -85.678)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2805-2",
    "data-name": "Ellipse 2805",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -20.287)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2941-2",
    "data-name": "Ellipse 2941",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2942-2",
    "data-name": "Ellipse 2942",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2943-2",
    "data-name": "Ellipse 2943",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2944-2",
    "data-name": "Ellipse 2944",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2872-2",
    "data-name": "Ellipse 2872",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2807-2",
    "data-name": "Ellipse 2807",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2873-2",
    "data-name": "Ellipse 2873",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2808-2",
    "data-name": "Ellipse 2808",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2945-2",
    "data-name": "Ellipse 2945",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2947-2",
    "data-name": "Ellipse 2947",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2948-2",
    "data-name": "Ellipse 2948",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2874-2",
    "data-name": "Ellipse 2874",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2875-2",
    "data-name": "Ellipse 2875",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2810-2",
    "data-name": "Ellipse 2810",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2949-2",
    "data-name": "Ellipse 2949",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2951-2",
    "data-name": "Ellipse 2951",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2952-2",
    "data-name": "Ellipse 2952",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2876-2",
    "data-name": "Ellipse 2876",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2877-2",
    "data-name": "Ellipse 2877",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2812-2",
    "data-name": "Ellipse 2812",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2953-2",
    "data-name": "Ellipse 2953",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2878-2",
    "data-name": "Ellipse 2878",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2955-2",
    "data-name": "Ellipse 2955",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -75.547)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2814-2",
    "data-name": "Ellipse 2814",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -10.156)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2879-2",
    "data-name": "Ellipse 2879",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2880-2",
    "data-name": "Ellipse 2880",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2881-2",
    "data-name": "Ellipse 2881",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2882-2",
    "data-name": "Ellipse 2882",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2885-2",
    "data-name": "Ellipse 2885",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2887-2",
    "data-name": "Ellipse 2887",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2888-2",
    "data-name": "Ellipse 2888",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2891-2",
    "data-name": "Ellipse 2891",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2893-2",
    "data-name": "Ellipse 2893",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2894-2",
    "data-name": "Ellipse 2894",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2897-2",
    "data-name": "Ellipse 2897",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2900-2",
    "data-name": "Ellipse 2900",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -64.495)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2902-2",
    "data-name": "Ellipse 2902",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2903-2",
    "data-name": "Ellipse 2903",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2904-2",
    "data-name": "Ellipse 2904",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2905-2",
    "data-name": "Ellipse 2905",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2989-2",
    "data-name": "Ellipse 2989",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(32.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2990-2",
    "data-name": "Ellipse 2990",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(116.235 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2991-2",
    "data-name": "Ellipse 2991",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(0 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2992-2",
    "data-name": "Ellipse 2992",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(85 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2908-2",
    "data-name": "Ellipse 2908",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2910-2",
    "data-name": "Ellipse 2910",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2911-2",
    "data-name": "Ellipse 2911",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2993-2",
    "data-name": "Ellipse 2993",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(43.287 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2995-2",
    "data-name": "Ellipse 2995",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(11.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2996-2",
    "data-name": "Ellipse 2996",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(95.052 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2914-2",
    "data-name": "Ellipse 2914",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2916-2",
    "data-name": "Ellipse 2916",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2917-2",
    "data-name": "Ellipse 2917",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2997-2",
    "data-name": "Ellipse 2997",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(54.339 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2999-2",
    "data-name": "Ellipse 2999",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(22.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3000-2",
    "data-name": "Ellipse 3000",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(106.104 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2920-2",
    "data-name": "Ellipse 2920",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -53.443)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3001-2",
    "data-name": "Ellipse 3001",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(64.47 -117.914)",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3003-2",
    "data-name": "Ellipse 3003",
    cx: 1.842,
    cy: 1.842,
    r: 1.842,
    transform: "translate(75.523 -117.914)",
    fill: "#090909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14486",
    "data-name": "Group 14486",
    transform: "translate(-69 8037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    transform: "translate(337 332)",
    fill: "#e6f3ec",
    stroke: "#bdd5c9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 175,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 339,
    height: 174,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "EUR",
    transform: "translate(403.645 387)",
    fill: "#111",
    fontSize: 20,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "EUR")), /*#__PURE__*/React.createElement("text", {
    id: "_5_007.00",
    "data-name": "\\u20AC 5,007.00",
    transform: "translate(357 469.333)",
    fill: "#111",
    fontSize: 36,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20AC 5,007.00")), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 301,
    transform: "translate(357 415.666)",
    fill: "none",
    stroke: "#bdd5c9",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "eu",
    transform: "translate(357 370)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M0,0H32.44V22.33H0Z",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7425",
    "data-name": "Group 7425",
    transform: "translate(8.799 3.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7357",
    "data-name": "Group 7357",
    transform: "translate(6.321 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(0.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M-6.8-23.7l-.316,1.054.527.105Z",
    transform: "translate(7.111 23.704)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.782 0.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7352",
    "data-name": "Group 7352",
    transform: "translate(1.222 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-2",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7353",
    "data-name": "Group 7353",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.193, 1.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-3",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7356",
    "data-name": "Group 7356",
    transform: "translate(1.417 2.092) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7354",
    "data-name": "Group 7354",
    transform: "translate(0.12 1.306) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-4",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7355",
    "data-name": "Group 7355",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.511, 1.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-5",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7363",
    "data-name": "Group 7363",
    transform: "translate(6.321 12.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-2",
    "data-name": "b",
    transform: "translate(0.784 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-6",
    "data-name": "a",
    d: "M-6.8-23.7l-.316,1.054.527.105Z",
    transform: "translate(7.111 23.704)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-2",
    "data-name": "c",
    transform: "translate(0.782 0.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7358",
    "data-name": "Group 7358",
    transform: "translate(1.222 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-7",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7359",
    "data-name": "Group 7359",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.193, 1.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-8",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7362",
    "data-name": "Group 7362",
    transform: "translate(1.417 2.092) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7360",
    "data-name": "Group 7360",
    transform: "translate(0.12 1.306) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-9",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7361",
    "data-name": "Group 7361",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.511, 1.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-10",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "e",
    transform: "translate(0 0.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7369",
    "data-name": "Group 7369",
    transform: "translate(0 5.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-3",
    "data-name": "b",
    transform: "translate(0.784 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-11",
    "data-name": "a",
    d: "M-6.8-23.7l-.316,1.054.527.105Z",
    transform: "translate(7.111 23.704)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-3",
    "data-name": "c",
    transform: "translate(0.782 0.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7364",
    "data-name": "Group 7364",
    transform: "translate(1.222 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-12",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7365",
    "data-name": "Group 7365",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.193, 1.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-13",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7368",
    "data-name": "Group 7368",
    transform: "translate(1.417 2.092) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7366",
    "data-name": "Group 7366",
    transform: "translate(0.12 1.306) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-14",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7367",
    "data-name": "Group 7367",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.511, 1.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-15",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7375",
    "data-name": "Group 7375",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 4.608, 2.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-4",
    "data-name": "b",
    transform: "translate(0.784 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-16",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-4",
    "data-name": "c",
    transform: "translate(0.782 0.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7370",
    "data-name": "Group 7370",
    transform: "translate(1.222 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-17",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7371",
    "data-name": "Group 7371",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.193, 1.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-18",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7374",
    "data-name": "Group 7374",
    transform: "translate(1.417 2.092) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7372",
    "data-name": "Group 7372",
    transform: "translate(0.12 1.306) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-19",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7373",
    "data-name": "Group 7373",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.511, 1.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-20",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7381",
    "data-name": "Group 7381",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 3.503, 4.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-5",
    "data-name": "b",
    transform: "translate(0.784 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-21",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-5",
    "data-name": "c",
    transform: "translate(0.782 0.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7376",
    "data-name": "Group 7376",
    transform: "translate(1.222 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-22",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7377",
    "data-name": "Group 7377",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.193, 1.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-23",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7380",
    "data-name": "Group 7380",
    transform: "translate(1.417 2.092) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7378",
    "data-name": "Group 7378",
    transform: "translate(0.12 1.306) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-24",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7379",
    "data-name": "Group 7379",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.511, 1.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-25",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7387",
    "data-name": "Group 7387",
    transform: "translate(2.658 8.795) rotate(72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-6",
    "data-name": "b",
    transform: "translate(0.784 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-26",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-6",
    "data-name": "c",
    transform: "translate(0.782 0.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7382",
    "data-name": "Group 7382",
    transform: "translate(1.222 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-27",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7383",
    "data-name": "Group 7383",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.193, 1.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-28",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7386",
    "data-name": "Group 7386",
    transform: "translate(1.417 2.092) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7384",
    "data-name": "Group 7384",
    transform: "translate(0.12 1.306) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-29",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7385",
    "data-name": "Group 7385",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.511, 1.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-30",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7393",
    "data-name": "Group 7393",
    transform: "translate(4.944 10.915) rotate(72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-7",
    "data-name": "b",
    transform: "translate(0.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-31",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-7",
    "data-name": "c",
    transform: "translate(0.782 0.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7388",
    "data-name": "Group 7388",
    transform: "translate(1.222 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-32",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7389",
    "data-name": "Group 7389",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.193, 1.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-33",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7392",
    "data-name": "Group 7392",
    transform: "translate(1.417 2.092) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7390",
    "data-name": "Group 7390",
    transform: "translate(0.12 1.306) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-34",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7391",
    "data-name": "Group 7391",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.511, 1.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-35",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7424",
    "data-name": "Group 7424",
    transform: "translate(14.841 14.115) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7399",
    "data-name": "Group 7399",
    transform: "translate(0 5.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-8",
    "data-name": "b",
    transform: "translate(0.784 0.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-36",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-8",
    "data-name": "c",
    transform: "translate(0.782 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7394",
    "data-name": "Group 7394",
    transform: "translate(0.12 1.306) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-37",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7395",
    "data-name": "Group 7395",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.511, 1.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-38",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7398",
    "data-name": "Group 7398",
    transform: "translate(1.417 1.664) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7396",
    "data-name": "Group 7396",
    transform: "translate(1.222 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-39",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7397",
    "data-name": "Group 7397",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.193, 1.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-40",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7405",
    "data-name": "Group 7405",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 5.838, 12.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-9",
    "data-name": "b",
    transform: "translate(0.784 0.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-41",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-9",
    "data-name": "c",
    transform: "translate(0.782 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7400",
    "data-name": "Group 7400",
    transform: "translate(0.12 1.306) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-42",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7401",
    "data-name": "Group 7401",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.511, 1.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-43",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7404",
    "data-name": "Group 7404",
    transform: "translate(1.417 1.664) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7402",
    "data-name": "Group 7402",
    transform: "translate(1.222 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-44",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7403",
    "data-name": "Group 7403",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.193, 1.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-45",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7411",
    "data-name": "Group 7411",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 2.274, 11.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-10",
    "data-name": "b",
    transform: "translate(0.784 0.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-46",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-10",
    "data-name": "c",
    transform: "translate(0.782 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7406",
    "data-name": "Group 7406",
    transform: "translate(0.12 1.306) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-47",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7407",
    "data-name": "Group 7407",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.511, 1.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-48",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7410",
    "data-name": "Group 7410",
    transform: "translate(1.417 1.664) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7408",
    "data-name": "Group 7408",
    transform: "translate(1.222 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-49",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7409",
    "data-name": "Group 7409",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.193, 1.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-50",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7417",
    "data-name": "Group 7417",
    transform: "translate(0.668 4.212) rotate(-72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-11",
    "data-name": "b",
    transform: "translate(0.784 0.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-51",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-11",
    "data-name": "c",
    transform: "translate(0.782 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7412",
    "data-name": "Group 7412",
    transform: "translate(0.12 1.306) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-52",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7413",
    "data-name": "Group 7413",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.511, 1.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-53",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7416",
    "data-name": "Group 7416",
    transform: "translate(1.417 1.664) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7414",
    "data-name": "Group 7414",
    transform: "translate(1.222 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-54",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7415",
    "data-name": "Group 7415",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.193, 1.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-55",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7423",
    "data-name": "Group 7423",
    transform: "translate(2.955 2.092) rotate(-72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-12",
    "data-name": "b",
    transform: "translate(0.784 0.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-56",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-12",
    "data-name": "c",
    transform: "translate(0.782 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7418",
    "data-name": "Group 7418",
    transform: "translate(0.12 1.306) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-57",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7419",
    "data-name": "Group 7419",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.511, 1.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-58",
    "data-name": "a",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7422",
    "data-name": "Group 7422",
    transform: "translate(1.417 1.664) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7420",
    "data-name": "Group 7420",
    transform: "translate(1.222 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-59",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7421",
    "data-name": "Group 7421",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.193, 1.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-60",
    "data-name": "a",
    d: "M.316,0,0,1.054l.527.105Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M.316,1.159,0,.105.527,0Z",
    transform: "translate(0.632 1.159) rotate(180)",
    fill: "#fc0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7485",
    "data-name": "Group 7485",
    transform: "translate(-88 205)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(742 147)",
    fill: "#848b9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(742 154)",
    fill: "#848b9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(742 161)",
    fill: "#848b9c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14488",
    "data-name": "Group 14488",
    transform: "translate(89 8099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    transform: "translate(337 722)",
    fill: "#434343",
    stroke: "rgba(255,255,255,0.1)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 175,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 339,
    height: 174,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_240-japan",
    "data-name": "240-japan",
    transform: "translate(357 759)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 33.5,
    height: 22.334,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 6.281,
    cy: 6.281,
    r: 6.281,
    transform: "translate(10.469 4.885)",
    fill: "#d80027"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_1_31_453.00",
    "data-name": "\\xA5 1,31,453.00",
    transform: "translate(357 859.333)",
    fill: "#fff",
    fontSize: 36,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xA5 1,31,453.00")), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 302,
    transform: "translate(356 805.666)",
    fill: "none",
    stroke: "#515151",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "JPY",
    transform: "translate(403.646 777)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "JPY")), /*#__PURE__*/React.createElement("g", {
    id: "Group_7487",
    "data-name": "Group 7487",
    transform: "translate(-88 595)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-2",
    "data-name": "Ellipse 18",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(742 147)",
    fill: "#848b9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-2",
    "data-name": "Ellipse 19",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(742 154)",
    fill: "#848b9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-2",
    "data-name": "Ellipse 20",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(742 161)",
    fill: "#848b9c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14487",
    "data-name": "Group 14487",
    transform: "translate(-69 8027.338)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 298, 341.66)",
    filter: "url(#Rectangle_19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_19-2",
    "data-name": "Rectangle 19",
    transform: "translate(39 185)",
    fill: "#fff",
    stroke: "#bdd5c9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 498,
    height: 257,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 497,
    height: 256,
    rx: 11.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "GBP",
    transform: "translate(434.609 600.435)",
    fill: "#111",
    fontSize: 29,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GBP")), /*#__PURE__*/React.createElement("g", {
    id: "_109-united_kingdom",
    "data-name": "109-united kingdom",
    transform: "translate(366.294 576.294)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 46.871,
    height: 31.247,
    transform: "translate(0 0)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M26.365,85.33H20.506V98.024H0v5.859H20.506v12.694h5.859V103.883H46.871V98.024H26.365Z",
    transform: "translate(0 -85.33)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(28.53 21.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M393.785,315.358l10.822,6.012v-6.012Z",
    transform: "translate(-386.266 -315.358)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M311.652,315.358l18.341,10.189v-2.881l-13.154-7.308Z",
    transform: "translate(-311.652 -315.358)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M325.107,352.474,311.652,345v7.476Z",
    transform: "translate(-311.652 -342.285)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M311.652,315.358l18.341,10.189v-2.881l-13.154-7.308Z",
    transform: "translate(-283.122 -294.3)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M311.652,315.358l18.341,10.189v-2.881l-13.154-7.308Z",
    transform: "translate(-283.122 -294.3)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(0 21.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M8.27,315.356,0,319.951v-4.595Z",
    transform: "translate(0 -315.356)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M41.5,329.51V338.4H25.491Z",
    transform: "translate(-23.157 -328.214)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M13.154,315.358,0,322.666v2.881H0l18.341-10.189Z",
    transform: "translate(0 -294.3)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M10.822,136.97,0,130.958v6.012Z",
    transform: "translate(0 -126.781)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M18.341,95.519,0,85.33v2.881l13.154,7.308Z",
    transform: "translate(0 -85.33)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M53.366,85.33l13.455,7.476V85.33Z",
    transform: "translate(-48.481 -85.33)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M18.341,95.519,0,85.33v2.881l13.154,7.308Z",
    transform: "translate(0 -85.33)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M18.341,95.519,0,85.33v2.881l13.154,7.308Z",
    transform: "translate(0 -85.33)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(28.53 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M421.659,151.041l8.27-4.595v4.595Z",
    transform: "translate(-411.589 -140.851)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M311.652,94.225V85.331h16.007Z",
    transform: "translate(-311.652 -85.331)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M316.838,95.519l13.154-7.308V85.33h0L311.652,95.519Z",
    transform: "translate(-283.122 -85.33)",
    fill: "#d80027"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_45_746.00",
    "data-name": "\\xA3 45,746.00",
    transform: "translate(366.294 721.129)",
    fill: "#111",
    fontSize: 52,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xA3 45,746.00")), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 440.876,
    transform: "translate(366.294 643.181)",
    fill: "none",
    stroke: "#bdd5c9",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7486",
    "data-name": "Group 7486",
    transform: "translate(801.312 554.829)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-3",
    "data-name": "Ellipse 18",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(-0.312 -0.168)",
    fill: "#848b9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-3",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(-0.312 9.832)",
    fill: "#848b9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-3",
    "data-name": "Ellipse 20",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(-0.312 20.832)",
    fill: "#848b9c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollect4);
export default __webpack_public_path__ + "static/media/collect_4.f0de8abcfc19a6357470c8a86099d0a9.svg";
export { ForwardRef as ReactComponent };